import { uniq } from 'lodash';

import { ReactionsMap } from '@web/conversations/types/Reactions';
import {
  MAX_MESSAGE_REACTIONS,
  MAX_MESSAGE_USER_REACTIONS,
} from '@web/conversations/Reactions/consts/reactionLimits';

type Props = {
  currentUserId: ID;
  reactions: ReactionsMap;
};

export const canApplyReaction = ({ currentUserId, reactions }: Props) => {
  if (reactions[currentUserId]?.length >= MAX_MESSAGE_USER_REACTIONS) {
    return false;
  }

  const uniqueReactions = uniq(Object.values(reactions).flat());

  if (uniqueReactions.length >= MAX_MESSAGE_REACTIONS) {
    return false;
  }

  return true;
};
